/**
 * The format contract, next to the box it applies to.
 *
 * The parser recognises four headings and turns everything else into a plain
 * section, so an author is never blocked — but they can only rely on that if
 * they know which four. Collapsed by default: it is a reminder, not a lesson.
 *
 * The fenced blocks below have insert buttons above the body field; they stay
 * listed here because an author editing an existing one still has to recognise
 * it.
 */

import { Typography } from "@/components/common/Typography/Typography"
import type { TranslationKeys } from "@/hooks/useTranslation/useTranslation"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"

const HINTS: { syntax: string; key: TranslationKeys }[] = [
  { syntax: "## Voraussetzungen", key: "HELPDESK/EDITOR_HINT_PREREQUISITES" },
  { syntax: "## Schritte + ### Titel", key: "HELPDESK/EDITOR_HINT_STEPS" },
  { syntax: "## Danach", key: "HELPDESK/EDITOR_HINT_AFTERWARD" },
  {
    syntax: "## Wenn etwas nicht klappt",
    key: "HELPDESK/EDITOR_HINT_ISSUES",
  },
  {
    syntax: ":::tip … ::: / :::warning … :::",
    key: "HELPDESK/EDITOR_HINT_CALLOUT",
  },
  {
    syntax: ':::cta {href="/pfad" label="Text"} … :::',
    key: "HELPDESK/EDITOR_HINT_CTA",
  },
  { syntax: "{{Stammdaten}}", key: "HELPDESK/EDITOR_HINT_REFERENCE" },
]

export function HelpdeskEditorHints() {
  const { translate } = useTranslation()

  return (
    <details className="rounded-lg border border-white/6 px-M py-2.5">
      <summary className="cursor-pointer list-none text-xs text-grey5 hover:text-white">
        {translate("HELPDESK/EDITOR_FORMAT")}
      </summary>
      <dl className="mt-3 flex flex-col gap-2">
        {HINTS.map((hint) => (
          <div key={hint.syntax} className="flex flex-col gap-0.5">
            <dt className="font-mono text-[12px] text-white/80">
              {hint.syntax}
            </dt>
            <dd>
              <Typography as="span" variant="textXS" className="text-white/45">
                {translate(hint.key)}
              </Typography>
            </dd>
          </div>
        ))}
      </dl>
    </details>
  )
}
